import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {AttributeWhitelist, IAttributeWhitelist} from 'app/blocks/model/attribute-whitelist.model';
import {AttributeWhitelistService} from 'app/blocks/service/api/attribute-whitelist.service';

@Injectable({
    providedIn: 'root'
})
export class AttributeWhitelistResource extends AbstractEntityResource<IAttributeWhitelist> {
    constructor(attributeWhitelistService: AttributeWhitelistService, router: Router) {
        super(
            Resource.PRODUCT_ATTRIBUTE_WHITELIST,
            attributeWhitelistService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.PRODUCT_ATTRIBUTE_WHITELIST, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.PRODUCT_ATTRIBUTE_WHITELIST),
            (entity?) => new AttributeWhitelist(entity),
            (entity) => entity.name,
            'money'
        );
    }
}
